import { render, staticRenderFns } from "./SenderDetail.vue?vue&type=template&id=2f855d0e"
import script from "./SenderDetail.vue?vue&type=script&lang=js"
export * from "./SenderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports